
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxWorkflowAddGroups(
    GroupListService, $timeout, $http, $q, $filter, toastr, GroupListPOSTPaging, GroupFilterModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        exclude: '=exclude',
        tenant: "=tenant",
        closeDialog: '&closeDialog',
        return: '&return',
      },
      templateUrl: 'app/components/settings/workflows/addGroups/workflowAddGroups.template.html',
      link: function(scope) {

        scope.groupListPaging = new GroupListPOSTPaging();
        scope.groupList = [];
        scope.noGroupSelected = true;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        var exludedGroups = angular.copy(scope.exclude)
        scope.searchString = '';
        scope.groupsLoaded = 0;
        scope.groupsTotal = 0;
        scope.selectedGroups = [];
        scope.unSelectedGroups = [];
        var pageSections = {};

        (function() {
          customKeyBinding = true;
          scope.filtersList = new GroupFilterModel('WORKFLOW_GROUPS').filters;
        })();

        scope.getFirstGroupsPage = function () {
          getFirstGroupsPage();
        }

        function excludeGroups () {
          scope.groupListPaging.pagingCriteria.exclude = exludedGroups.map(group => group.info._links.self.href)
        }

        function getFirstGroupsPage() {
          excludeGroups();
          scope.groupListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.groupList = [];
          pageSections = {};

          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function (response) {
            angular.element('.add-group-dialog').scrollTop(0);
            pageSections[response.page.number] = response
            scope.totalPages = response.page.totalPages;
            scope.groupList = response.list;
            scope.loadingPage = false;
            scope.groupsTotal = response.page.totalElements
            scope.groupsLoaded = scope.groupList.length;
          }).catch(function(error){});
        }

        scope.textSearch = function () {
          scope.groupListPaging.pagingCriteria.match = scope.searchString;
          angular.element('.add-group-dialog').scrollTop(0);
          getFirstGroupsPage();
        }


        function getNextGroupsPage () {
          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.groupListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){
              pageSections[response.page.number] = response
              if (response.list) {
                scope.groupList = scope.groupList.concat(response.list);
              }
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }).catch(function(error){});
          }
        }

        function getThisPageSection (pageSection) {
          var pageSectionsKeys = Object.keys(pageSections).length -1;
          excludeGroups();

          scope.groupListPaging.pagingCriteria.page = pageSection
          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){

            if (pageSection < pageSectionsKeys) {
              pageSections[pageSection] = response
              getThisPageSection(pageSection += 1)
            } else {
              var pageSectionList = []
              pageSections[pageSection] = response

              for(var key in pageSections) {
                pageSectionList = pageSectionList.concat(pageSections[key].list)
              }

              scope.groupList = pageSectionList
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }

          }).catch(function(error){});
        }

        angular.element('.pagination-content-large').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextGroupsPage();
              }, 300)
            }
          }
        });


        scope.addLoadedGroups = function () {
          scope.loadingPage = true;
          scope.selectedGroups = scope.selectedGroups.concat(scope.groupList)
          exludedGroups = exludedGroups.concat(scope.groupList)

          getFirstGroupsPage()
        }

        scope.removeSelectedGroups = function () {
          scope.loadingPage = true;
          scope.selectedGroups = []
          exludedGroups = []
          getFirstGroupsPage()
        }

        scope.addGroup = function (group, index) {
          scope.loadingPage = true;
          scope.selectedGroups.push(group);
          scope.selectedGroups = scope.selectedGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));
          exludedGroups = scope.selectedGroups;
          getThisPageSection(getSectionFromItemIndex(index));
        }

        function getSectionFromItemIndex(index) {
          return Math.floor(index / 20);
        }

        scope.removeGroup = function (group) {
          scope.loadingPage = true;
          scope.selectedGroups = scope.selectedGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
          exludedGroups = scope.selectedGroups;
          var index = findInsertionIndex(group.info.name);
          getThisPageSection(getSectionFromItemIndex(index));
        }

        function findInsertionIndex(name) {
          let left = 0;
          let right = scope.groupList.length - 1;

          while (left <= right) {
            const middle = Math.floor((left + right) / 2);
            const middleItemName = scope.groupList[middle].info.name;

            if (middleItemName === name) {
              return middle; // Item already exists at this index
            }

            if (name < middleItemName) {
              right = middle - 1; // Search in the left half
            } else {
              left = middle + 1; // Search in the right half
            }
          }

          return left; // Return the index where the item should be inserted
        }


        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.returnSelectedGroups = function () {
          scope.return({groups: scope.selectedGroups});
        }

        scope.close = function () {
          scope.closeDialog();
        }

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

      }
    };
  }

  pxWorkflowAddGroups.$inject = [
    'GroupListService', '$timeout', '$http', '$q', '$filter', 'toastr', 'GroupListPOSTPaging', 'GroupFilterModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkflowAddGroups', pxWorkflowAddGroups);

})();
